export default __webpack_public_path__ + "static/media/grid-view-active.7ef9eaeb.svg";